module.exports = __webpack_public_path__ + "img/bg.5c23dbd.jpg";